import { Component, OnInit, ViewChild, Input, ElementRef, OnDestroy, AfterViewInit } from "@angular/core"; import { Location } from "@angular/common";
import { BreadcrumbService } from '../../app.breadcrumb.service';
import { MenuItem } from 'primeng/api';
import { MessageService, LazyLoadEvent, ConfirmationService } from 'primeng/api';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ItemService } from '../../services/item-service';
import { Router, ActivatedRoute } from '@angular/router';
import { BaseComponent } from '../../base/base-component';
import { EmplacementService } from '../../services/emplacement-service';
import { AchatService } from '../../services/achat-service';
import { BonCommandeEntite } from '../../entites/bon-commande';
import { CleValeur } from 'src/app/entites/cleValeur';
import { DonneesBaseService } from 'src/app/services/donnees-base-service';
import { ProfilService } from 'src/app/services/profil-service';
import { ItemBonCommande } from 'src/app/entites/item-bon-commande';
import { SelectionItemComponent, ETypeSelectionItem, ResultatSelectionItem } from 'src/app/controles/selection-item.component';
import { EStatuts } from 'src/app/entites/enums/statuts';
import { RapportService } from 'src/app/services/rapport-service';
import { DatePipe } from '@angular/common';
import { EnvoiBonCommandeComponent } from 'src/app/controles/envoi-bon-commande.component';
import { AppMainComponent } from 'src/app/app.main.component';
import { ModificationItemBonCommandeComponent } from './controles/modification-item-bon-commande.component';
import { Fournisseur } from 'src/app/entites/fournisseur';
import { CodeProjetEntite } from 'src/app/entites/code-projet';
import { FournisseurService } from 'src/app/services/fournisseur-service';
import { PieceService } from 'src/app/services/piece-service';
import { Title } from '@angular/platform-browser';
import { environment } from "src/environments/environment";
import { peutUtiliserWebShare } from 'src/app/services/web-share';
import { AjouterAdresseEmplacementComponent } from "../emplacement/controles/ajouter-adresse-emplacement/ajouter-adresse-emplacement.component";
import { EmplacementAdresseEntite } from "src/app/entites/emplacement-adresse-entite";
import { doitCreerCommandeDepuisLigneBonCommande } from './bon-commande-commande.helpers';
import { MessageInformationService } from 'src/app/services/message-information.service';
import { MessageInformationGuids } from 'src/app/entites/message-information.guids';
import { AdresseEntite } from 'src/app/entites/adresse';

@Component({
    selector: 'app-detail-bdc',
    templateUrl: './detail-achat.component.html',
    providers: [MessageService, ConfirmationService, DialogService, DatePipe]
})
export class DetailAchatComponent extends BaseComponent implements OnInit, AfterViewInit, OnDestroy {

    @Input('bdcId') inputBdcId: number;

    modeApercu: boolean = false;

    bonCommandeId: number;
    bonCommande: BonCommandeEntite;
    selectionEntree: ItemBonCommande;
    selectionMultipleEntree: ItemBonCommande[] = [];

    codeActiviteId?: number = null;
    codeCategorieId?: number = null;
    codeEquipementId?: number = null;
    indAjoutCommande: boolean = false;
    selectionDemandeurId?: number = null;
    selectionUniteId?: number = null;
    selectionEmplacementCommandeId?: number = null;


    frequences: CleValeur[];
    selectionFrequence: CleValeur;

    fournisseurs: Fournisseur[];
    listeCodeProjet: CodeProjetEntite[];

    prixTotal: number = 0.0;

    ref: DynamicDialogRef;

    menu: MenuItem[];

    /** Indicateur session : un job CTRL différé d'une minute a été mis en file ici. */
    syncCtrlPlanifiee = false;
    private syncPlanifieeTimer?: ReturnType<typeof setTimeout>;

    @ViewChild('descriptionItem') champDescription: ElementRef;

    constructor(
        public sdb: DonneesBaseService,
        profilService: ProfilService,
        route: ActivatedRoute,
        appMain: AppMainComponent, location: Location, 
        private breadcrumbService: BreadcrumbService,
        private achatService: AchatService,
        private EmplacementService: EmplacementService,
        private ItemsService: ItemService,
        private fournisseurService: FournisseurService,
        private rapportService: RapportService,
        public titleService: Title,
        private pieceService: PieceService,
        private messageService: MessageService,
        private confirmationService: ConfirmationService,
        private messageInformationService: MessageInformationService,
        public dialogService: DialogService,
        public routerService: Router,
        public datepipe: DatePipe) {

        super(sdb, profilService, route, routerService, appMain);

        this.breadcrumbService.setItems([
            { label: 'Bons de commande', routerLink: '/achats' },
            { label: 'Détails' }
        ]);

        this.route.params.subscribe(params => this.bonCommandeId = params.id);
    }

    ngOnInit() {

        if (this.inputBdcId) {
            this.bonCommandeId = this.inputBdcId;
            this.modeApercu = true;
        }

        this.verifierAccesPage('bdc_detail');

        this.colonnesDisponibles = [
            { base: true, champ: 'numero', entete: 'No SIHC', afficheParDefaut: true },
            { base: true, champ: 'description', entete: 'Description', afficheParDefaut: true },
            { base: true, champ: 'statut.nom', entete: 'Statut', afficheParDefaut: true },
            { base: true, champ: 'noFournisseur', entete: 'No pièce fournisseur', afficheParDefaut: true },
            { base: true, champ: 'quantite', entete: 'Quantité', afficheParDefaut: true },
            { base: true, champ: 'unite', entete: 'Unité', afficheParDefaut: true },
            { base: true, champ: 'prix', entete: 'Prix', afficheParDefaut: true },
            { base: true, champ: 'codeExtra.code', entete: 'Extra', afficheParDefaut: true },
            { base: true, champ: 'projet', entete: 'Code de projet', afficheParDefaut: true },
            { base: true, champ: 'activite', entete: 'Code d\'activité', afficheParDefaut: true },
            { base: true, champ: 'emplacement', entete: 'Emplacement', afficheParDefaut: true }
        ];
        this.colonnesSelectionnees = this.colonnesDisponibles.filter(x => x.afficheParDefaut);

        this.listeCodeProjet = this.sdb.CodesProjet();

        this.frequences = [
            { cle: 'N', valeur: 'Aucune' },
            { cle: 'J', valeur: 'Jours' },
            { cle: 'H', valeur: 'Semaine' },
            { cle: 'M', valeur: 'Mois' },
            { cle: 'A', valeur: 'Année' },
            { cle: 'D', valeur: 'Détaillée' }
        ]

        var p1 = new Promise<number>((resolve, reject) => {


            this.achatService.ObtenirBonCommande(this.bonCommandeId).then(x => {

                this.bonCommande = x.valeur;
                this.normaliserDatesBonCommande();

                this.titleService.setTitle(`SIHC - ${this.bonCommande.numero}`);

                if (this.bonCommande.projet) {
                    this.bonCommande.projet = this.listeCodeProjet.find(x => x.codeProjetId == this.bonCommande.projet.codeProjetId);
                }

                if (this.bonCommande.frequence) {
                    this.selectionFrequence = this.frequences.find(x => x.cle == this.bonCommande.frequence);
                }

                this.majPrixTotal();

                resolve(null);
            });
        });

        var p3 = new Promise<number>((resolve, reject) => {
            this.fournisseurService.ObtenirFournisseurs().then(x => {
                this.fournisseurs = x.valeur;
                resolve(null);
            });
        });

        Promise.all([p1, p3]).then(x => {
            this.bonCommande.fournisseur = this.fournisseurs.find(x => x.fournisseurId == this.bonCommande.fournisseur.fournisseurId);

            this.initialiserMenu();

            this.CompleterChargement(`Bon de commande #${this.bonCommande?.numero} (${this.bonCommande?.fournisseur?.nom})`);

            if (!this.modeApercu) {
                this.messageInformationService.afficher(MessageInformationGuids.BdcEditionInlineEnregistrementAuto);
            }
        });



        this.colonnesDisponibles = [
            { champ: 'categorie', entete: 'Catégorie', afficheParDefaut: false },
            { champ: 'sousCategorie', entete: 'Sous-catégorie', afficheParDefaut: false },
            { champ: 'marque', entete: 'Marque', afficheParDefaut: false },
            { champ: 'modele', entete: 'Modèle', afficheParDefaut: false },
            { champ: 'noSerie', entete: 'No série', afficheParDefaut: false },
            { champ: 'noPlaque', entete: 'No plaque', afficheParDefaut: false },
            { champ: 'poids', entete: 'Poids', afficheParDefaut: false }
        ];

        this.colonnesSelectionnees = this.colonnesDisponibles.filter(x => x.afficheParDefaut);

    }

    ngAfterViewInit() {
        this.chargerColonnesSelectionnees();
    }

    ngOnDestroy() {
        this.annulerSyncPlanifiee();
        this.titleService.setTitle(`SIHC`);
    }

    private marquerSyncPlanifiee(): void {
        this.syncCtrlPlanifiee = true;
        if (this.syncPlanifieeTimer) {
            clearTimeout(this.syncPlanifieeTimer);
        }
        this.syncPlanifieeTimer = setTimeout(() => {
            this.syncCtrlPlanifiee = false;
            this.syncPlanifieeTimer = undefined;
        }, 70_000);
    }

    /** Première sync (numéro encore « 0 ») : le job est immédiat, ne pas afficher « sous peu ». */
    private marquerSyncApresMutation(): void {
        const numero = this.bonCommande?.numero;
        if (!numero || numero === '0' || !this.bonCommande?.dateDerniereSyncCtrl) {
            this.annulerSyncPlanifiee();
            return;
        }
        this.marquerSyncPlanifiee();
    }

    private annulerSyncPlanifiee(): void {
        this.syncCtrlPlanifiee = false;
        if (this.syncPlanifieeTimer) {
            clearTimeout(this.syncPlanifieeTimer);
            this.syncPlanifieeTimer = undefined;
        }
    }

    initialiserMenu() {

        this.estModifiable = this.bonCommande.statut.statutId == EStatuts.EnCours ||
            this.bonCommande.statut.statutId == EStatuts.EnCorrection;

        this.menu = [
            {
                label: 'Retour', icon: 'pi pi-fw pi-angle-double-left', command: () => window.history.back()
            },
            {
                label: 'Imprimer', icon: 'pi pi-fw pi-print', command: () => this.imprimer(),
                disabled: !this.modeConsultation()
            },
            {
                label: 'Envoyer', icon: 'pi pi-fw pi-send',
                visible: this.estAutorise('bdc_courriel'),
                disabled: this.bonCommande.numero == '0' || !this.modeConsultation(),
                command: () => this.envoyer()
            },
            {
                label: 'Partager', icon: 'pi pi-fw pi-share-alt',
                visible: peutUtiliserWebShare(),
                disabled: this.bonCommande.numero == '0' || !this.modeConsultation(),
                items: [
                    {
                        label: 'Lien', icon: 'pi pi-fw pi-link', command: () => this.partager()
                    },
                    {
                        label: 'PDF', icon: 'pi pi-fw pi-file-pdf', command: () => this.partagerPdf()
                    }
                ]
            },
            {
                label: 'Actions', icon: 'pi pi-fw pi-bars',
                disabled: !this.modeConsultation(),
                items: [
                    {
                        label: 'Obtenir numéro', icon: 'pi pi-fw pi-dollar',
                        visible: this.estAutorise('bdc_numero_ctrl'),
                        disabled: this.bonCommande.numero != '0' || this.bonCommande.statut.statutId == EStatuts.Complete,
                        command: () => this.ObtenirNumeroCtrl()
                    },
                    {
                        label: 'Transférer vers CTRL', icon: 'pi pi-fw pi-dollar',
                        visible: this.estAutorise('bdc_transfert_ctrl'),
                        disabled: this.bonCommande.statut.statutId == EStatuts.Complete,
                        command: () => this.TransfertCtrl()
                    },
                    {
                        label: 'Compléter sans transfert vers CTRL', icon: 'pi pi-fw pi-dollar',
                        visible: this.estAutorise('bdcs_completer'),
                        disabled: this.bonCommande.statut.statutId == EStatuts.Complete,
                        command: () => this.CompleterSansTransfert()
                    },
                    {
                        label: 'Corriger le bon de commande', icon: 'pi pi-fw pi-pencil',
                        visible: this.estAutorise('bdc_modifier') && this.bonCommande.statut.statutId == EStatuts.Complete && this.bonCommande.numero != '0',
                        command: () => this.corriger()
                    },
                    {
                        label: "Voir les documents associés", icon: 'pi pi-fw pi-file',
                        visible: this.estAutorise('emplacement_detail'),
                        command: () => this.routerService.navigateByUrl('emplacement/' + this.bonCommande.emplacement.emplacementId + '?tab=3')
                    },
                    {
                        label: 'Rendre privé', icon: 'icon-hat-glasses',
                        visible: this.estAutorise('bdc_action_rendre_prive')
                            && this.estCreateur()
                            && !this.bonCommande.indPrive,
                        command: () => this.rendreBonCommandeIndPrive(true)
                    },
                    {
                        label: 'Rendre public', icon: 'pi pi-fw pi-eye',
                        visible: this.estAutorise('bdc_action_rendre_prive')
                            && this.estCreateur()
                            && !!this.bonCommande.indPrive,
                        command: () => this.rendreBonCommandeIndPrive(false)
                    },
                    { separator: true },
                    {
                        label: 'Supprimer le bon de commande', icon: 'pi pi-fw pi-times',
                        visible: this.estAutorise('bdc_supprimer'),
                        disabled: this.bonCommande.statut.statutId != EStatuts.EnCours,
                        styleClass: 'menuSuppression',
                        command: () => this.supprimerbonCommande()
                    }
                ]
            },
            {
                label: 'Actions multiples', icon: 'pi pi-fw pi-bars',
                visible: this.estAutorise('bdc_modifier'),
                disabled: !this.peutModifierContenu || this.selectionMultipleEntree.length == 0,
                items: [
                    {
                        label: 'Supprimer', icon: 'pi pi-fw pi-times', styleClass: 'menuSuppression', command: () => this.supprimerItems(this.selectionMultipleEntree)
                    },
                ]
            },
        ];
    }

    get peutModifierContenu(): boolean {
        const statutId = this.bonCommande?.statut?.statutId;
        return !this.modeApercu
            && (statutId === EStatuts.EnCours || statutId === EStatuts.EnCorrection)
            && this.estAutorise('bdc_modifier');
    }

    estLigneComplete(item?: ItemBonCommande): boolean {
        return item?.statut?.statutId === EStatuts.Complete;
    }

    obtenirTooltipStatutEdition(): string {
        if (this.peutModifierContenu) {
            return [
                'Ce bon de commande est modifiable.',
                'Cliquez sur un champ pour le modifier ; la valeur est enregistrée automatiquement lorsque vous quittez le champ.',
                'Aucun bouton « Enregistrer » n\'est nécessaire pour ces modifications.'
            ].join('\n\n');
        }
        if (this.modeApercu) {
            return 'Mode aperçu : ouvrez la fiche complète pour modifier le document.';
        }
        if (!this.estModifiable) {
            return 'Ce bon de commande n\'est plus modifiable. Les champs sont en lecture seule.';
        }
        return 'Vous n\'avez pas la permission de modifier ce bon de commande. Les champs sont en lecture seule.';
    }

    afficherFrequence = (f: CleValeur | string) => {
        if (!f) return '';
        if (typeof f === 'string') return this.frequences.find(x => x.cle === f)?.valeur ?? f;
        return f.valeur ?? '';
    };

    afficherProjet = (p?: CodeProjetEntite) => {
        if (!p) return '';
        return p.code && p.nom ? `${p.code} — ${p.nom}` : (p.nom || p.code || '');
    };

    afficherFournisseur = (f?: Fournisseur) => {
        if (!f) return '';
        return f.numero ? `${f.nom} (${f.numero})` : (f.nom || '');
    };

    afficherAdresseLivraison = (_?: AdresseEntite) => {
        const b = this.bonCommande;
        if (!b) return '';
        if (b.adresse) {
            const parts = [
                b.emplacement?.nom,
                b.adresse.nom,
                [b.adresse.numero, b.adresse.rue, b.adresse.municipalite, b.adresse.codePostal]
                    .filter(x => x).join(', ')
            ].filter(x => x);
            return parts.join(' → ');
        }
        if (b.emplacement) {
            return b.emplacement.code ? `${b.emplacement.nom} (${b.emplacement.code})` : (b.emplacement.nom || '');
        }
        return '';
    };

    sauvegarderChamp(champ: string, valeur: any): void {
        if (!this.peutModifierContenu) {
            return;
        }
        this.achatService.ModifierChamp(this.bonCommandeId, champ, valeur).subscribe({
            next: (res) => {
                if (res?.estUnSucces && res.valeur) {
                    this.appliquerRetourServeur(res.valeur);
                    if (res.valeur.syncCtrlEnAttente) {
                        this.marquerSyncApresMutation();
                    }
                    this.achatService.RemovePagesWithBonCommandeId(this.bonCommandeId);
                } else {
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Erreur',
                        detail: res?.messages?.[0]?.description || 'Échec de la sauvegarde'
                    });
                    this.rechargerDetail();
                }
            },
            error: () => {
                this.messageService.add({ severity: 'error', summary: 'Erreur', detail: 'Échec de la sauvegarde' });
                this.rechargerDetail();
            }
        });
    }

    private appliquerRetourServeur(valeur: BonCommandeEntite): void {
        this.bonCommande = valeur;
        this.normaliserDatesBonCommande();
        if (this.bonCommande.projet) {
            this.bonCommande.projet = this.listeCodeProjet.find(x => x.codeProjetId == this.bonCommande.projet.codeProjetId)
                ?? this.bonCommande.projet;
        }
        if (this.bonCommande.fournisseur && this.fournisseurs) {
            this.bonCommande.fournisseur = this.fournisseurs.find(x => x.fournisseurId == this.bonCommande.fournisseur.fournisseurId)
                ?? this.bonCommande.fournisseur;
        }
        if (this.bonCommande.frequence) {
            this.selectionFrequence = this.frequences.find(x => x.cle == this.bonCommande.frequence);
        }
        this.majPrixTotal();
        this.initialiserMenu();
    }

    private normaliserDatesBonCommande(): void {
        if (this.bonCommande?.dateAchat) {
            this.bonCommande.dateAchat = new Date(this.bonCommande.dateAchat);
        }
        if (this.bonCommande?.requisLe) {
            this.bonCommande.requisLe = new Date(this.bonCommande.requisLe);
        }
    }

    private rechargerDetail(): void {
        this.achatService.ObtenirBonCommande(this.bonCommandeId).then(x => {
            if (x?.valeur) {
                this.appliquerRetourServeur(x.valeur);
            }
        });
    }

    ouvrirFicheComplete() {
        this.routerService.navigateByUrl('achat/' + this.bonCommandeId);
    }

    imprimer() {
        this.messageService.add({ severity: 'info', summary: 'Demande de rapport', detail: `Votre demande de rapport a été envoyée.` });

        this.rapportService.ProduireRapportBonCommande(this.bonCommande.bonCommandeId).then(x => {
            if (x) {
                this.messageService.add({ severity: 'success', summary: 'Succès', detail: `Votre rapport a été généré.` });
            } else {
                this.messageService.add({ severity: 'error', summary: 'Erreur', detail: `Une erreur est survenue pendant la génération de votre rapport.` });
            }
        });
    }

    btnModifier_click() {
        this.Modifier();
        this.initialiserMenu();
    }

    annulerModification() {
        this.DemarrerChargement();

        this.achatService.ObtenirBonCommande(this.bonCommandeId).then(x => {

            this.bonCommande = x.valeur;
            this.bonCommande.dateAchat = new Date(this.bonCommande.dateAchat);
            this.bonCommande.fournisseur = this.fournisseurs.find(x => x.fournisseurId == this.bonCommande.fournisseur.fournisseurId);
            this.bonCommande.projet = this.listeCodeProjet.find(x => x.codeProjetId == this.bonCommande.projet.codeProjetId);
            this.bonCommande.emplacement = this.sdb.Emplacement(this.bonCommande.emplacement.emplacementId);
            this.bonCommande.numero = x.valeur.numero;
            this.bonCommande.projet = x.valeur.projet;
            this.bonCommande.fournisseur = x.valeur.fournisseur;
            this.bonCommande.employe = x.valeur.employe;
            this.bonCommande.note = x.valeur.note;
            this.initialiserMenu();

            this.CompleterChargement(`Bon de commande #${this.bonCommande.numero} (${this.bonCommande.fournisseur?.nom})`)
        });

        this.Consulter();

        this.initialiserMenu();
    }

    submitted = false;

    enregistrerModifications() {
        this.submitted = true;
        this.messageService.clear();

        if (this.validerModificationBdc()) {
            this.DemarrerChargement();

            this.bonCommande.frequence = this.selectionFrequence?.cle;

            //!\ L'adresse doit être enlevé si elle est nulle ou vide. Ne pas toucher. /!\
            this.bonCommande.adresse = this.bonCommande.adresse?.adresseId == null ? null : this.bonCommande.adresse;

            this.achatService.ModifierBonCommande(this.bonCommande).then(x => {
                this.CompleterChargement();
                if (x.estUnSucces) {
                    this.Consulter();
                    this.initialiserMenu();
                    this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Bon de commande modifié.' });
                    this.achatService.RemovePagesWithBonCommandeId(this.bonCommande.bonCommandeId);
                } else {
                    x.messages.forEach(x => {
                        this.messageService.add({ severity: 'error', summary: 'Erreur', detail: x.description, sticky: true });
                    });

                }

            });


        }
    }

    validerModificationBdc(): boolean {

        if (!this.bonCommande.fournisseur) {
            return false;
        }

        if (!this.bonCommande.emplacement && !this.bonCommande.adresse) {
            return false;
        }

        if (!this.bonCommande.projet) {
            return false;
        }

        if (!this.bonCommande.dateAchat) {
            return false;
        }

        return true;
    }


    estCreateur(): boolean {
        return this.bonCommande?.employe?.employeId === this.profilService.ProfilCourant()?.employeId;
    }

    rendreBonCommandeIndPrive(indPrive: boolean) {
        this.confirmationService.confirm({
            message: indPrive
                ? 'Ce bon de commande ne sera plus visible que par vous. Continuer ?'
                : 'Ce bon de commande redeviendra visible pour les utilisateurs autorisés. Continuer ?',
            header: indPrive ? 'Rendre privé' : 'Rendre public',
            icon: indPrive ? 'pi pi-eye-slash' : 'pi pi-eye',
            accept: () => {
                this.achatService.RendreBonsCommandePrivesLot([this.bonCommande.bonCommandeId], indPrive).then(res => {
                    if (res.estUnSucces) {
                        this.bonCommande.indPrive = indPrive;
                        this.initialiserMenu();
                        this.achatService.ClearCacheBonsCommande();
                        this.messageService.add({
                            severity: 'success',
                            summary: 'Succès',
                            detail: indPrive ? 'Bon de commande rendu privé.' : 'Bon de commande rendu public.'
                        });
                    } else {
                        res.messages.forEach(x => {
                            this.messageService.add({ severity: 'error', summary: 'Erreur', detail: x.description });
                        });
                    }
                });
            }
        });
    }

    supprimerbonCommande() {
        this.confirmationService.confirm({
            target: event.target,
            message: 'Voulez-vous vraiment supprimer le bon de commande courant ?',
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.achatService.SupprimerBonCommande(this.bonCommande.bonCommandeId).then(res => {
                    if (res.estUnSucces) {
                        this.routerService.navigateByUrl('achats');
                        this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Bon de commande supprimé.' });
                        this.achatService.ClearCacheBonsCommande();
                    } else {
                        res.messages.forEach(x => {
                            this.messageService.add({ severity: 'error', summary: 'Erreur', detail: x.description });
                        });
                    }
                });

            }
        });
    }


    supprimerItems(itemsBonsCommande: ItemBonCommande[]) {
        itemsBonsCommande = (itemsBonsCommande ?? []).filter(x => !this.estLigneComplete(x));
        if (itemsBonsCommande.length === 0) {
            return;
        }
        var ids = itemsBonsCommande.map(b => b.itemBonCommandeId);
        this.confirmationService.confirm({
            target: event.target,
            message: itemsBonsCommande.length == 1 ? 'Voulez-vous vraiment supprimer l\'item sélectionné ?' : 'Voulez-vous vraiment supprimer les items sélectionnés ?',
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.achatService.SupprimerItemsBonCommande(ids).then(res => {
                    if (res.estUnSucces) {
                        this.bonCommande.itemsBonCommande = this.bonCommande.itemsBonCommande.filter((ibc: ItemBonCommande) => !ids.includes(ibc.itemBonCommandeId))
                        this.bonCommande.syncCtrlEnAttente = true;
                        this.marquerSyncApresMutation();
                        this.majPrixTotal();
                        this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Bon de commande supprimé.' });
                        this.achatService.RemovePagesWithBonCommandeId(this.bonCommande.bonCommandeId);
                    } else {
                        res.messages.forEach(x => {
                            this.messageService.add({ severity: 'error', summary: 'Erreur', detail: x.description });
                        });
                    }
                });

            }
        });
    }

    modifierItemBonCommande(itemBonCommande: ItemBonCommande) {

        const ref = this.dialogService.open(ModificationItemBonCommandeComponent, {
            data: {
                itemBonCommande: itemBonCommande
            },
            header: 'Modifier un item',
            width: '90%'
        }).onClose.subscribe((res: ItemBonCommande) => {
            if (res) {
                itemBonCommande.quantite = res.quantite;
                itemBonCommande.noFournisseur = res.noFournisseur;
                itemBonCommande.prix = res.prix;
                itemBonCommande.codeProjet = res.codeProjet;
                itemBonCommande.codeActivite = res.codeActivite;
                itemBonCommande.codeCategorie = res.codeCategorie;
                itemBonCommande.note = res.note;
                itemBonCommande.uniteQte = res.uniteQte;

                this.majPrixTotal();
                this.achatService.RemovePagesWithBonCommandeId(this.bonCommande.bonCommandeId);

                this.messageService.add({ severity: 'success', summary: 'Succès', detail: `Item modifié.` });
            }

        });

    }


    estFenetreAjoutItemActive: boolean = false;
    modifierOuAjouterItem(item?: ItemBonCommande) {
        if (item && this.estLigneComplete(item)) {
            return;
        }
        this.estFenetreAjoutItemActive = true;
        const ref = this.dialogService.open(SelectionItemComponent, {
            data: {
                type: ETypeSelectionItem.BonCommande,
                item: item?.item,
                fournisseurId: this.bonCommande.fournisseur.fournisseurId,
                selectionCodeProjet: item?.codeProjet?.codeProjetId || this.bonCommande.projet?.codeProjetId,
                selectionCodeActivite: item?.codeActivite?.codeActiviteId || this.codeActiviteId,
                selectionCodeCategorie: item?.codeCategorie?.codeCategorieId || this.codeCategorieId,
                selectionCodeEquipement: item?.codeEquipement?.codeEquipementId || this.codeEquipementId,
                selectionCodeExtra: item?.codeExtra?.codeExtraId,
                selectionEmplacement: item?.emplacement?.emplacementId,
                indAjoutCommande: doitCreerCommandeDepuisLigneBonCommande(!!item?.indCommande, this.indAjoutCommande),
                selectionDemandeurId: this.selectionDemandeurId,
                selectionUniteId: this.selectionUniteId,
                selectionEmplacementCommandeId: this.selectionEmplacementCommandeId,
                quantite: item?.quantite,
                uniteQte: item?.uniteQte,
                noFournisseur: item?.noFournisseur,
                prix: item?.prix,
                indCommande: item?.indCommande,
            },
            header: item ? 'Modification de la sélection d\'un item' : 'Sélection d\'un item',
            width: '95%'
        }).onClose.subscribe(async (res: ResultatSelectionItem) => {
            this.estFenetreAjoutItemActive = false;
            if (res) {
                let reponse = null;
                this.Bloquer();

                if (item) {
                    reponse = await this.achatService.ModifierItemBonCommande({
                        itemBonCommandeId: item.itemBonCommandeId,
                        bonCommande: bdc,
                        bonCommandeId: this.bonCommande.bonCommandeId,
                        item: res.item,
                        noFournisseur: res.noFournisseur,
                        quantite: res.quantiteDemande,
                        note: res.note,
                        prix: res.prix,
                        codeProjet: res.codeProjet,
                        codeActivite: res.codeActivite,
                        codeCategorie: res.codeCategorie,
                        codeEquipement: res.codeEquipement,
                        codeExtra: res.codeExtra,
                        emplacement: res.emplacement,
                        indConserverPrix: true,
                        indAjoutCommande: doitCreerCommandeDepuisLigneBonCommande(!!item.indCommande, res.indAjoutCommande),
                        demandeur: res.demandeur,
                        dateDemande: res.dateDemande,
                        dateRequis: res.dateRequis,
                        emplacementIdAjoutCommande: res.emplacementAjoutCommande?.emplacementId,
                        uniteIdAjoutCommande: res.uniteAjoutCommande?.itemId,
                        uniteQte: res.uniteQte,
                        indAssociation: res.indAssociation,
                        categorieEntretienId: res.categorieEntretienId,
                    }).catch(x => {
                        this.Debloquer();
                    });
                }
                else {
                    //Ceci est pour empêcher une récursion infinie
                    var bdc = { ...this.bonCommande };
                    bdc.itemsBonCommande = [];
                    //Ceci est pour empêcher une récursion infinie

                    reponse = await this.achatService.CreerItemBonCommande({
                        itemBonCommandeId: 0,
                        bonCommande: bdc,
                        bonCommandeId: this.bonCommande.bonCommandeId,
                        item: res.item,
                        noFournisseur: res.noFournisseur,
                        quantite: res.quantiteDemande,
                        note: res.note,
                        prix: res.prix,
                        codeProjet: res.codeProjet,
                        codeActivite: res.codeActivite,
                        codeCategorie: res.codeCategorie,
                        codeEquipement: res.codeEquipement,
                        codeExtra: res.codeExtra,
                        emplacement: res.emplacement,
                        indConserverPrix: true,
                        indAjoutCommande: res.indAjoutCommande,
                        demandeur: res.demandeur,
                        dateDemande: res.dateDemande,
                        dateRequis: res.dateRequis,
                        emplacementIdAjoutCommande: res.emplacementAjoutCommande?.emplacementId,
                        uniteIdAjoutCommande: res.uniteAjoutCommande?.itemId,
                        uniteQte: res.uniteQte,
                        indAssociation: res.indAssociation,
                        categorieEntretienId: res.categorieEntretienId,
                    }).catch(x => {
                        this.Debloquer();
                    });
                }

                if (reponse.estUnSucces) {
                    let itemExistant = this.bonCommande.itemsBonCommande.find(x => x.itemBonCommandeId == reponse.valeur.itemBonCommandeId);
                    if (itemExistant) {
                        itemExistant.quantite = reponse.valeur.quantite;
                        itemExistant.noFournisseur = reponse.valeur.noFournisseur;
                        itemExistant.prix = reponse.valeur.prix;
                        itemExistant.codeProjet = reponse.valeur.codeProjet;
                        itemExistant.codeActivite = reponse.valeur.codeActivite;
                        itemExistant.codeCategorie = reponse.valeur.codeCategorie;
                        itemExistant.codeEquipement = reponse.valeur.codeEquipement;
                        itemExistant.codeExtra = reponse.valeur.codeExtra;
                        itemExistant.emplacement = reponse.valeur.emplacement;
                        itemExistant.note = reponse.valeur.note;
                        itemExistant.uniteQte = reponse.valeur.uniteQte;
                        if (reponse.valeur.indCommande != null) {
                            itemExistant.indCommande = reponse.valeur.indCommande;
                        }
                        if (reponse.valeur.item) {
                            itemExistant.item = reponse.valeur.item;
                        }
                    } else {
                        this.bonCommande.itemsBonCommande.push(reponse.valeur);
                    }

                    this.bonCommande.syncCtrlEnAttente = true;
                    this.marquerSyncApresMutation();
                    this.majPrixTotal();
                }

                for (const message of reponse.messages) {
                    this.messageService.add({ severity: message.severity, summary: 'Information', detail: message.description });
                }

                this.Debloquer();

                this.codeActiviteId = res.codeActivite?.codeActiviteId;
                this.codeCategorieId = res.codeCategorie.codeCategorieId;
                this.codeEquipementId = res.codeEquipement?.codeEquipementId;
                this.indAjoutCommande = res.indAjoutCommande;
                this.selectionDemandeurId = res.demandeur?.employeId;
                this.selectionUniteId = res.uniteAjoutCommande?.itemId;
                this.selectionEmplacementCommandeId = res.emplacementAjoutCommande?.emplacementId;

            }

            this.achatService.RemovePagesWithBonCommandeId(this.bonCommande.bonCommandeId);
        });
    }

    majPrixTotal() {
        this.prixTotal = 0.0;
        this.bonCommande.itemsBonCommande.forEach(x => {
            if (x.quantite && x.prix) {
                this.prixTotal += (x.quantite * x.prix);
            }
        });
    }

    surChangementSelection() {
        this.initialiserMenu();
    }

    ObtenirNumeroCtrl() {
        this.Bloquer();

        this.achatService.ObtenirNumeroCtrl(this.bonCommande.bonCommandeId).then(res => {
            this.Debloquer();
            if (res.estUnSucces) {
                this.messageService.add({ severity: 'success', summary: 'Bon de commande créé', detail: `Nouveau numéro du bon de commande: ${res.valeur}` });
                this.bonCommande.numero = res.valeur;
                this.titleService.setTitle(`SIHC - ${this.bonCommande.numero}`);
                this.initialiserMenu();
            } else {
                res.messages.forEach(x => {
                    this.messageService.add({ severity: 'error', summary: 'Erreur', detail: x.description, life: 10000 });
                });
            }
        })
    }

    TransfertCtrl() {

        this.confirmationService.confirm({
            message: `Voulez-vous vraiment transférer le bon de commande vers CTRL?`,
            accept: () => {
                this.Bloquer();
                this.achatService.TransfererVersCtrl({
                    bonCommandeId: this.bonCommande.bonCommandeId,
                    emplacementId: 10000 //TODO Hard-code 10000. 
                }).then(res => {
                    this.Debloquer();
                    if (res.estUnSucces) {
                        this.messageService.add({ severity: 'success', summary: 'Bon de commande transféré', detail: `Numéro du bon de commande: ${res.valeur}` });
                        this.bonCommande.numero = res.valeur;
                        this.bonCommande.statut = {
                            "statutId": 13,
                            "nom": "Complété"
                        };
                        this.initialiserMenu();
                    } else {
                        res.messages.forEach(x => {
                            this.messageService.add({ severity: 'error', summary: 'Erreur', detail: x.description, life: 10000 });
                        });
                    }
                })
            }
        });
    }

    CompleterSansTransfert() {

        this.confirmationService.confirm({
            message: `Voulez-vous vraiment compléter le bon de commande sans transfert vers CTRL?`,
            accept: () => {
                this.Bloquer();

                this.achatService.CompleterBonCommandeSansTransfertCtrl(this.bonCommande).then(x => {
                    this.Debloquer();
                    if (x.estUnSucces) {
                        this.bonCommande.statut = this.sdb.Statut(EStatuts.Complete);
                        this.Consulter();
                        this.initialiserMenu();
                        this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Bon de commande modifié.' });
                    } else {
                        x.messages.forEach(x => {
                            this.messageService.add({ severity: 'error', summary: 'Erreur', detail: x.description, sticky: true });
                        });

                    }

                });
            }
        });


    }

    corriger() {

        this.confirmationService.confirm({
            target: event.target,
            message: 'Voulez-vous vraiment corriger le bon de commande courant ?',
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.Bloquer();
                this.achatService.CorrigerBonCommande(this.bonCommande).then(res => {
                    this.Debloquer();
                    if (res.estUnSucces) {
                        this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Le bon de commande est maintenant en correction' });
                        this.bonCommande = res.valeur;
                        this.bonCommande.dateAchat = new Date(this.bonCommande.dateAchat);
                        this.bonCommande.fournisseur = this.fournisseurs.find(x => x.fournisseurId == this.bonCommande.fournisseur.fournisseurId);
                        this.bonCommande.projet = this.listeCodeProjet.find(x => x.codeProjetId == this.bonCommande.projet.codeProjetId);
                        this.bonCommande.emplacement = this.sdb.Emplacement(this.bonCommande.emplacement.emplacementId);
                        this.initialiserMenu();
                    } else {
                        res.messages.forEach(x => {
                            this.messageService.add({ severity: 'error', summary: 'Erreur', detail: x.description });
                        });
                    }

                });

            }
        });


    }

    surSauvegardeProjet(projet: CodeProjetEntite): void {
        this.bonCommande.projet = projet;
        this.sauvegarderChamp('projet', projet?.codeProjetId ?? null);
    }

    surSauvegardeFournisseur(fournisseur: Fournisseur): void {
        this.bonCommande.fournisseur = fournisseur;
        this.surChangementFournisseur();
    }

    surChangementFournisseur() {
        this.bonCommande.raisonFournisseur = null;
        this.sauvegarderChamp('fournisseur', this.bonCommande.fournisseur?.fournisseurId);
        if (this.fournisseurService.getQualityScore(this.bonCommande.fournisseur) == 'danger') {
            this.confirmationService.confirm({
                key: 'confirm-bad-supplier',
                message: 'Ce fournisseur a une note de qualité trop basse. Veuillez indiquer la raison de choisir ce fournisseur.',
                acceptLabel: 'Continuer',
                rejectLabel: 'Annuler',
                accept: () => {
                    this.sauvegarderChamp('raisonfournisseur', this.bonCommande.raisonFournisseur);
                },
                reject: () => {
                    this.bonCommande.raisonFournisseur = null;
                }
            });
        }
    }

    surChangementAdresseLivraison(adresse: AdresseEntite): void {
        this.bonCommande.adresse = adresse;
        this.sauvegarderChamp('adresse', adresse?.adresseId ?? null);
    }

    surChangementEmplacementLivraison(emplacementId: number): void {
        this.bonCommande.emplacement = this.sdb.Emplacement(emplacementId);
        this.sauvegarderChamp('emplacement', emplacementId ?? null);
    }

    surSauvegardeFrequence(valeur: CleValeur | string): void {
        const cle = typeof valeur === 'string' ? valeur : valeur?.cle;
        this.selectionFrequence = this.frequences.find(x => x.cle == cle);
        this.sauvegarderChamp('frequence', cle ?? null);
    }


    envoyer() {
        const ref = this.dialogService.open(EnvoiBonCommandeComponent, {
            data: {
                bonCommandeId: this.bonCommande.bonCommandeId,
                fournisseurId: this.bonCommande.fournisseur.fournisseurId
            },
            header: 'Envoi d\'un bon de commande',
            width: '60%'
        }).onClose.subscribe((res: boolean) => {
            if (res) {
                this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Le bon de commande a été envoyé.' });
                this.bonCommande.dateEnvoi = new Date();
            }


        });
    }

    partager() {
        navigator.share({
            title: 'SIHC - Bon de commande',
            text: 'Bon de commande #' + this.bonCommande.numero,
            url: environment.urlBase + '/achat/' + this.bonCommande.bonCommandeId
        });
    }

    partagerPdf() {
        this.rapportService.ObtenirPdfBonCommande(this.bonCommande.bonCommandeId).then(x => {
            if (x) {
                navigator.share({
                    title: 'SIHC - Bon de commande',
                    text: 'Bon de commande #' + this.bonCommande.numero,
                    files: [new File([x], 'bon_commande-' + this.bonCommande.numero + '.pdf', { type: 'application/pdf' })]
                });
            }
        }).catch(x => {
            this.messageService.add({ severity: 'error', summary: 'Erreur', detail: 'Impossible de partager le bon de commande au format PDF.' });
        });
    }

    get EStatuts() {
        return EStatuts;
    }
}
